import React from 'react';

import { GradCtaHeroBlockData } from 'api/cms';
import Box from 'components/Box';
import { CallToActionButton } from 'components/Button';
import Flex from 'components/Flex';
import { Hero } from 'components/Hero';
import { RichTextHeadline } from 'components/Text';
import { trackClicked } from 'utils/analytics';

type Props = {
  data: GradCtaHeroBlockData;
  loggedIn: boolean;
  hasGradProgram: boolean;
  isPageHeader?: boolean;
  blockIndex: number;
  pageUpdated: string;
};

export function GradCallToActionHeroBlock({
  data: { text, image, withOverlay },
  loggedIn,
  hasGradProgram,
  isPageHeader,
  blockIndex,
  pageUpdated,
}: Props) {
  return (
    <Hero
      withOverlay={withOverlay}
      heroImage={image}
      data-qa-id="grad-call-to-action-hero"
      minHeight="calc(100vh - 300px)"
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <RichTextHeadline
          mt={['48px', '48px', '48px', '80px']}
          mb={['18px', '18px', '18px', '42px']}
          color="white"
          textAlign="center"
          tag={isPageHeader ? 'h1' : undefined}
          $reverseUnderline
        >
          {text}
        </RichTextHeadline>
      </Box>
      <Flex>
        <CallToActionButton
          loggedIn={loggedIn}
          hasGradProgram={hasGradProgram}
          data-qa-id="grad-cta-button"
          onClick={() => {
            trackClicked('CMS Block', {
              block_position: blockIndex,
              block_type: 'Grad Call to Action Hero',
              cta_type: 'Button',
              page_updated: pageUpdated,
            });
          }}
        />
      </Flex>
    </Hero>
  );
}

export default GradCallToActionHeroBlock;
